import * as React from 'react';
import { InputProps } from '../../Input';
import { OmitPolyfill, TooltipCommonProps } from '../../common';
import type { SupportedWixLocales } from 'wix-design-systems-locale-utils';

export interface DateInputProps extends OmitPolyfill<InputProps, 'value'> {
  dataHook?: string;
  value?: Date | string;
  locale?: SupportedWixLocales;
  dateStyle?: 'short' | 'medium';
  validate?: boolean;
  onValidate?({
    format,
    validationType,
    value,
  }: {
    format?: string;
    validationType: 'outOfBoundsError' | 'formatError' | 'valid';
    value: string;
  }): void;
  clearButtonTooltipContent?: React.ReactNode;
  clearButtonTooltipProps?: TooltipCommonProps;
  focusOnClearClick?: boolean;
}

export default class DateInput extends React.PureComponent<DateInputProps> {}
